import "../../assets/MessageBubble.css";
import { jsxs as g, jsx as _ } from "react/jsx-runtime";
import h from "dayjs";
const d = "_messageBubble_kfnwh_1", x = "_messageRight_kfnwh_8", B = "_messageLeft_kfnwh_11", T = "_messageRightText_kfnwh_14", p = "_messageLeftText_kfnwh_18", R = "_messageBubbleText_kfnwh_22", L = "_messageBubbleInfo_kfnwh_28", s = {
  messageBubble: d,
  messageRight: x,
  messageLeft: B,
  messageRightText: T,
  messageLeftText: p,
  messageBubbleText: R,
  messageBubbleInfo: L
}, k = "MMM D, YYYY - h:mm A", y = ({
  messageText: m,
  createdAt: o,
  author: t,
  activeUserUuid: i,
  messageThreadPatientUuid: u,
  patientName: a,
  providerName: b,
  isPatientUi: r = !1
}) => {
  const n = () => r && t.type != "provider" || !r && t.type === "provider", c = () => {
    const e = t.type === "parent_guardian";
    return n() ? u === i && e ? "Parent/Guardian" : e ? "You (Parent/Guardian)" : "You" : t.type === "patient" ? a : e ? `${a}'s Parent/Guardian` : b;
  }, f = () => h(o).format(k), l = () => {
    const e = n() ? s.messageRightText : s.messageLeftText;
    return `${s.messageBubbleText} ${e}`;
  };
  return /* @__PURE__ */ g("div", { className: (() => {
    const e = n() ? s.messageRight : s.messageLeft;
    return `${s.messageBubble} ${e}`;
  })(), children: [
    /* @__PURE__ */ _("div", { className: l(), children: m }),
    /* @__PURE__ */ g("div", { className: s.messageBubbleInfo, children: [
      c(),
      " • ",
      f()
    ] })
  ] });
};
export {
  y as MessageBubble
};
